/**
 * Bootstrap Icons base URL.
 *
 * This used to live in components/mc/mc-shared.ts, which moved to kohosting.app
 * with the Minecraft panel. It is a constant, not a Minecraft thing, so it now
 * sits on its own rather than being imported across a product boundary.
 */
export const ICON_CDN = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons';
